import React, { useMemo, useState } from 'react';
import ClinicInfo from './info/ClinicInfo';
import Hours from './hours/Hours';
import RecallHours from './recall/RecallHours';
import ClBrands from './ClBrands';
import SocialLinks from './SocialLinks';
import AppointmentNotes from './AppointmentNotes';
import WebBooking from './webbooking/WebBooking';
import ClinicSettingsNav from './subparts/ClinicSettingsNav';

const SETTINGS_TABS = [
    { id: 'general', label: 'General', icon: 'bi-building' },
    { id: 'hours', label: 'Hours', icon: 'bi-clock' },
    { id: 'recall-hours', label: 'Recall Settings', icon: 'bi-arrow-repeat' },
    { id: 'clbrands', label: 'Contact Lens Brands', icon: 'bi-eye' },
    { id: 'social-links', label: 'Social Links', icon: 'bi-share' },
    { id: 'appointment-notes', label: 'Appointment Notes', icon: 'bi-journal-text' },
    { id: 'webbooking', label: 'Web Booking', icon: 'bi-globe2' },
];

function TabCard() {
    const [activeTab, setActiveTab] = useState('general');
    const [loadedTabs, setLoadedTabs] = useState(() => new Set(['general']));

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setLoadedTabs((prev) => new Set([...prev, tabId]));
    };

    const tabContent = useMemo(
        () => ({
            general: <ClinicInfo />,
            hours: <Hours />,
            'recall-hours': <RecallHours />,
            clbrands: <ClBrands />,
            'social-links': <SocialLinks />,
            'appointment-notes': <AppointmentNotes />,
            webbooking: <WebBooking />,
        }),
        []
    );

    return (
        <div className="row g-3 clinic-settings-layout">
            <div className="col-12 col-lg-3 col-xl-3">
                <ClinicSettingsNav
                    tabs={SETTINGS_TABS}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
            </div>

            <div className="col-12 col-lg-9 col-xl-9">
                <div className="ecx-page-card ecx-page-panel clinic-settings-panel">
                    <div className="ecx-page-panel__body ecx-page-scroll">
                        {SETTINGS_TABS.map((tab) =>
                            loadedTabs.has(tab.id) ? (
                                <div
                                    key={tab.id}
                                    className={activeTab === tab.id ? '' : 'd-none'}
                                >
                                    {tabContent[tab.id]}
                                </div>
                            ) : null
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TabCard;
